import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MAX_BULK_VIDEOS } from '../../../common/model/dto/video/video-constants';
import { RejectedVideoFile } from '../../../common/model/type/video-file.types';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvStagedFileNoticesProps {
  rejected: RejectedVideoFile[];
  duplicates: string[];
}

const OvStagedFileNotices: FC<OvStagedFileNoticesProps> = ({
  rejected,
  duplicates,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {rejected.length > 0 && (
        <Rejected aria-label={t('videos.staging.rejectedLabel')}>
          {rejected.map(({ key, name, reason }) => (
            <li key={key}>
              {t('videos.staging.rejectedFile', {
                name,
                reason: t(`videos.staging.rejections.${reason}`, {
                  max: MAX_BULK_VIDEOS,
                }),
              })}
            </li>
          ))}
        </Rejected>
      )}

      {duplicates.length > 0 && (
        <Duplicates>
          {duplicates.map((name, index) => (
            <li key={`${name}-${index}`}>
              {t('videos.staging.duplicate', { name })}
            </li>
          ))}
        </Duplicates>
      )}
    </>
  );
};

export default OvStagedFileNotices;

const Rejected = styled.ul`
  margin: 0;
  padding-left: 1.25rem;
  color: ${Colours.OV_ERROR_ACCESSIBLE};
  font-size: ${Variables.fontSizes.SMALL};
`;

const Duplicates = styled.ul`
  margin: 0;
  padding-left: 1.25rem;
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};
`;
